/**
 * /frontend/src/features/analytics/components/peak/FootfallHeatmap.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import HeatmapGrid from '../charts/HeatmapGrid';
import { toHeatmapRows } from '../../utils/chartDataTransformers';

/**
 * Footfall heatmap component.
 * @param {{heatmap:any}} props
 * @returns {JSX.Element}
 */
const FootfallHeatmap = ({ heatmap }) => {
  const rows = useMemo(() => toHeatmapRows(heatmap), [heatmap]);
  return (
    <ChartContainer title="Footfall Heatmap" subtitle="Joins by day-of-week and hour-of-day">
      <HeatmapGrid rows={rows} />
    </ChartContainer>
  );
};

export default FootfallHeatmap;

